import React from "react";
import { ChevronDownIcon, ChevronUpIcon } from "./Icons.jsx";

export const SectionHeader = ({
	title,
	isExpanded,
	onToggle,
	hasActiveFilters,
}) => (
	<button className="section-header" onClick={onToggle}>
		<div className="section-header-content">
			<h3 className="section-title">{title}</h3>
			{hasActiveFilters && <span className="active-filter-indicator" />}
		</div>
		{isExpanded ? <ChevronUpIcon /> : <ChevronDownIcon />}
	</button>
);
